import { sha256 } from 'js-sha256';
import { msisdnRegex, emailRegex } from '../constants/validation';
import storage from '../helpers/storage';

let visitor_asset = null;
let visitor_email = null;
const STORE_USER_DETAILS = 'loginState:accessToken';

export const setTealiumUser = (userDetails) => {
  const contact = userDetails?.contact?.trim();
  const email = userDetails?.email?.trim() || (emailRegex.test(contact) ? contact : null);
  const msisdn = userDetails?.msisdn?.trim() || (msisdnRegex.test(contact) ? contact : null);

  if (email) {
    visitor_asset = sha256(email);
  }
  if (msisdn) {
    visitor_email = sha256(msisdn);
  }
};

export const getTealiumUserIds = () => ({
  visitor_asset,
  visitor_email
});

export const getTealiumUserData = async () => {
  const userResponse = await storage.getItem(STORE_USER_DETAILS);
  const {visitor_email,visitor_asset} = getTealiumUserIds();
  const visitor_id_marketing_email = userResponse?.email ? sha256(userResponse.email) : visitor_asset;
  const visitor_id_asset_active = userResponse?.msisdn ? sha256(userResponse.msisdn) : visitor_email;
  return { visitor_id_asset_active, visitor_id_marketing_email };
};
